import { render, staticRenderFns } from "./PersonalPoster.vue?vue&type=template&id=1a78d32d&scoped=true&"
import script from "./PersonalPoster.vue?vue&type=script&lang=js&"
export * from "./PersonalPoster.vue?vue&type=script&lang=js&"
import style0 from "./PersonalPoster.vue?vue&type=style&index=0&id=1a78d32d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a78d32d",
  null
  
)

export default component.exports